<template>

  <main id="renew2_login" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="login_container">
      <div class="renew2_wrapper renew2_flex">
        <div class="login_contents">
          <div class="renew2_flex lead">
            <h2>로그인</h2>
          </div>
          <p>Yagish의<a href="/kr/resume/terms" id="footer-link-terms" target="_blank">이용약관</a>,<a
              href="/kr/resume/privacy" class="" id="footer-link-terms" target="_blank">개인정보보호방침</a>에 동의한 후 로그인 해주세요.
          </p>
          <div class="login_block renew2_flex">
            <login-forms />
            <div class="login_block__02">
              <h3>아직 회원가입 하지 않으신분</h3>
              <p>백업정보를<br class="renew2_sp">편리하게 관리</p>
              <button class="register" @click="goRegister">회원가입</button>
              <ul class="point renew2_flex renew2_sp_flex">
                <li class="point__item">
                  <img src="/kr/resume/static/renew2_img/point01.svg" alt="다양한 템플릿보유">
                  <p>다양한 템플릿<br class="renew2_sp">을 보유</p>
                </li>
                <li class="point__item">
                  <img src="/kr/resume/static/renew2_img/point02.svg" alt="남녀노소 불문하고 간단">
                  <p>남녀노소<br class="renew2_sp">불문하고 간단</p>
                </li>
                <li class="point__item">
                  <img src="/kr/resume/static/renew2_img/point03.svg" alt="많은 분들이 이용">
                  <p>많은 분들이<br class="renew2_sp">이용</p>
                </li>
                <li class="point__item">
                  <img src="/kr/resume/static/renew2_img/point04.svg" alt="마이페이지에서 편리하게">
                  <p>마이페이지에서<br class="renew2_sp"> 편리하게!</p>
                </li>
              </ul>
              <a href="/kr/resume/info">yagish의 사용방법</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>

<script>
// import LoginForms from '@/components/RenewLoginForms'
import LoginForms from '@/components/IdPwLoginForms'
import firebase from 'firebase/app'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: true
    }
  },
  created: function () {
    console.log('new login created')
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log('New Login onAuthStateChanged')
        const urlParams = new URLSearchParams(window.location.search);
        var from_page = urlParams.get("frompage");
        if (from_page) {
          this.$router.push('/format/' + from_page + '/edit/output')
        } else {
          this.$router.push('/mypage')
        }
      }
      this.fullscreenLoading = false
    })
  },
  computed: {
  },
  mounted: function () {
  },
  methods: {
    goRegister: function () {
      this.$router.push('/mregister')
    },
    setFullscreenLoading: function (val) {
      this.fullscreenLoading = val
    },
    loginIdPw: function (id, pw) {
      this.fullscreenLoading = true
      this.$firebase.signInEmailPasswd(id, pw)
    }
  },
  watch: {},
  mounted: function () {
    this.$eventHub.$on('login-id-passwd', this.loginIdPw)
    this.$eventHub.$on('set-fullscreen-loading', this.setFullscreenLoading)
  },
  destroyed: function () {
    this.$eventHub.$off('login-id-passwd', this.loginIdPw)
    this.$eventHub.$off('set-fullscreen-loading', this.setFullscreenLoading)
  }
}
</script>
